import { FC } from "react";
import Head from "next/head";

interface DocumentTitleProps {
  title?: string;
}
const baseTitle = process.env.NEXT_PUBLIC_APP_NAME;

const DocumentTitle: FC<DocumentTitleProps> = ({ title = null }) => {
  const t = title ? `${title} | ${baseTitle}` : baseTitle;

  return (
    <Head>
      <title>{t}</title>
    </Head>
  );
};

export default DocumentTitle;
